import { render, staticRenderFns } from "./session-count.vue?vue&type=template&id=45155482&scoped=true&"
import script from "./session-count.vue?vue&type=script&lang=ts&"
export * from "./session-count.vue?vue&type=script&lang=ts&"
import style0 from "./session-count.vue?vue&type=style&index=0&id=45155482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45155482",
  null
  
)

export default component.exports